import { drawBanner, type DotColors } from '@bn-games/render-helpers';
import type { Color } from '../../game/types.js';
import { BOARD_OUTER_OFFSET, CANVAS_SIZE } from '../../utils/constants.js';
import type { RenderPalette } from '../palette.js';

/** What the banner shows; text is resolved (i18n) by the caller. */
export interface TurnBannerView {
  readonly text: string;
  readonly tone: 'turn' | 'win' | 'draw';
  /** Colour of the piece dot, or null for none. */
  readonly dot: Color | null;
}

const BANNER_HEIGHT = 30;
const BANNER_RADIUS = 15;
const BANNER_FONT = 'bold 14px "Segoe UI", system-ui, sans-serif';
const DOT_RADIUS = 9;
const CONTENT_PADDING = 18;

function dotColors(color: Color, palette: RenderPalette): DotColors {
  const white = color === 'w';
  return {
    base: white ? palette.whitePieceBase : palette.blackPieceBase,
    highlight: white ? palette.whitePieceHighlight : palette.blackPieceHighlight,
    shadow: white ? palette.whitePieceShadow : palette.blackPieceShadow,
    border: white ? palette.whitePieceBorder : palette.blackPieceBorder,
  };
}

export function drawTurnBanner(ctx: CanvasRenderingContext2D, view: TurnBannerView, palette: RenderPalette): void {
  const bg = view.tone === 'win' ? palette.bannerWinBg : view.tone === 'draw' ? palette.bannerDrawBg : palette.bannerBg;
  drawBanner(
    ctx,
    { text: view.text, bg, dot: view.dot === null ? null : dotColors(view.dot, palette) },
    palette,
    {
      canvasWidth: CANVAS_SIZE,
      y: (BOARD_OUTER_OFFSET - BANNER_HEIGHT) / 2,
      height: BANNER_HEIGHT,
      radius: BANNER_RADIUS,
      font: BANNER_FONT,
      dotRadius: DOT_RADIUS,
      contentPadding: CONTENT_PADDING,
      rotation: 0,
    },
  );
}
